const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'stretch',
  },

  status: {
    color: '#A9B0B8',
    position: 'relative',
    minWidth: 100,

    '&:before': {
      content: '""',
      display: 'inline-block',
      width: '8px',
      height: '8px',
      borderRadius: '100%',
      marginRight: '10px',
      backgroundColor: '#d5dee6',
    },
  },

  statusEnabled: {
    '&:before': {
      backgroundColor: '#47b881',
    },
  },
});

export default styles;
